export const isLoggedIn = () => {
    // Figure out something better than this to get this from redux
    const storeState = typeof window == "object" && localStorage.getItem("storeState");
    const storeStateParsed = storeState && JSON.parse(storeState);
    const security = storeStateParsed?.security || {} ;
    return !!security.token;
}